import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { AttendanceSessionKind, sessionsApi } from '@/services';

export const sessionKeys = {
  all: ['admin', 'attendance', 'sessions'] as const,
};

export function useSessionsQuery() {
  return useQuery({
    queryKey: sessionKeys.all,
    queryFn: () => sessionsApi.list(),
  });
}

export function useCreateSessionMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: {
      schoolYearId: string;
      kind: AttendanceSessionKind;
      name: string;
      startDate: string;
      endDate: string;
      active?: boolean;
    }) => sessionsApi.create(data),
    onSuccess: () => qc.invalidateQueries({ queryKey: sessionKeys.all }),
  });
}

export function useUpdateSessionMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      id,
      data,
    }: {
      id: string;
      data: Partial<{
        kind: AttendanceSessionKind;
        name: string;
        startDate: string;
        endDate: string;
        active: boolean;
      }>;
    }) => sessionsApi.update(id, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: sessionKeys.all }),
  });
}

export function useDeleteSessionMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => sessionsApi.remove(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: sessionKeys.all }),
  });
}
